import { render } from "./PersonalFundraisingDashboardMenu.vue?vue&type=template&id=6b4843ea"
import script from "./PersonalFundraisingDashboardMenu.vue?vue&type=script&lang=js"
export * from "./PersonalFundraisingDashboardMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__